import { useState, useEffect, useMemo } from 'react'
import { Typography } from '@mui/material'
import { motion, AnimatePresence } from 'motion/react'
import { useQuery } from '@tanstack/react-query'
import { axiosClient } from '../../data/axios'

const baseHeaderText = [
    'Staturday night',
    'Every week',
    'At 8pm UK time',
    'Not gwensday',
    'He has tier 2',
    'Losers Queue',
    'Namis feet',
    'Bard banned',
    'Aura farming'
]

export function RotatingHeader({ collapsed }: { collapsed: boolean }) {
    const [index, setIndex] = useState(0)

    const { data: playerCount } = useQuery<{ count: number }>({
        queryKey: ['players', 'count'],
        queryFn: () => axiosClient.get('/players/count').then((r) => r.data),
        staleTime: 60 * 60 * 1000,
    })

    const headerText = useMemo(() => {
        if (!playerCount) return baseHeaderText
        return [...baseHeaderText, `${playerCount.count} players`]
    }, [playerCount])

    useEffect(() => {
        if (collapsed) return

        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % headerText.length)
        }, 4000)

        return () => clearInterval(interval)
    }, [collapsed, headerText.length])

    if (collapsed) return null

    const safeIndex = index % headerText.length

    return (
        <Typography
            component="div"
            sx={{
                overflow: 'hidden',
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
                position: 'relative',
            }}
        >
            <AnimatePresence mode="wait">
                <motion.div
                    key={safeIndex}
                    initial={{ opacity: 0, y: 28 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -28 }}
                    transition={{ duration: 0.4 }}
                    style={{
                        willChange: 'transform, opacity',
                    }}
                >
                    {headerText[safeIndex]}
                </motion.div>
            </AnimatePresence>
        </Typography>
    )
}
